<template>
  <div class="input-wrapper">
    <div class="input-label">
      <div class="label-text">{{ label }}</div>
    </div>
    <div
      class="select-block"
      @click.stop="showOptions()"
      v-click-outside="hideOptions"
      :class="{'disabled': disabled}"
    >
      <input
        type="text"
        class="input"
        :disabled="disabled"
        v-model="inputValue"
        :placeholder="placeholder"
        :name="name"
        :class="{'input-disabled': disabled}"
      />
      <img
        src="../../../public/custom/images/arrow-down.svg"
        alt="Arrow down image"
      />
      <div class="dropdown-menu" :class="{'scrollable': optionsList.length > 3}" v-if="isShowOptions">
        <div
          v-for="option of optionsList"
          :key="option"
          class="option"
          @click.stop="chooseOption(option)"
        >
          {{ $t(`${dictionaryPath}${option}`) }}
        </div>
      </div>
    </div>
    <div class="error-block"></div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "BaseSelect",
  props: {
    label: String,
    placeholder: String,
    defaultValue: String,
    optionsList: Array,
    dictionaryPath: String,
    disabled: Boolean,
    name: String,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      inputValue: this.$t(`${this.dictionaryPath}${this.defaultValue || ""}`),
      isShowOptions: false,
    };
  },
  methods: {
    showOptions() {
      if (!this.disabled) {
        this.isShowOptions = true;
      }
    },
    chooseOption(value) {
      this.inputValue = this.$t(`${this.dictionaryPath}${value}`);
      this.hideOptions();
      this.$emit("input", value);
    },
    hideOptions() {
      this.isShowOptions = false;
    },
  },
  watch: {
    defaultValue(value) {
      this.inputValue = this.$t(`${this.dictionaryPath}${value}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  @include base-input-wrapper;
}

.input-label {
  @include base-input-label;
}

.select-block {
  @include base-input-block;
  height: 54px;
  padding-right: 9px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: var(--base-select-bgc);
}

.input {
  @include base-input;
  background-color: transparent;
  cursor: pointer;
  user-select: none;
  caret-color: transparent;
}

.error-block {
  @include base-input-error-block;
}

.dropdown-menu {
  width: calc(100% + 2px);
  height: auto;
  max-height: 230px;
  overflow: auto;
  box-sizing: border-box;
  position: absolute;
  top: -1px;
  left: -1px;
  background-color: var(--base-option-bgc);
  border-radius: var(--base-input-border-radius);
  border: 1px solid var(--base-options-list-border-color);
  z-index: 2;
  cursor: pointer;
}

.scrollable {
  border-radius: var(--base-input-border-radius) 0 0 var(--base-input-border-radius);
}

.option {
  height: 52px;
  padding: 12px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background-color: var(--base-option-bgc);
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  cursor: pointer;
}

.option:hover {
    background-color: var(--base-select-option-hover-bgc);
}

.option:first-of-type {
  border-radius: var(--base-option-bgc) var(--base-option-bgc) 0 0;
}

.option:last-of-type {
  border-radius: 0 0 var(--base-option-bgc) var(--base-option-bgc);
}

.dropdown-menu::-webkit-scrollbar {
    width: 3px;
    height: 10px;
    margin-right: 5px;
    scroll-padding-top: 5px;
}

.dropdown-menu {
    scroll-padding-top: 5px;
}

.dropdown-menu::-webkit-scrollbar-track {
    background-color: #ECEEF0;
    border-radius: 20px;
}

.dropdown-menu::-webkit-scrollbar-thumb {
    background-color: #878787;
    border-radius: 20px;
}

.disabled {
  background-color: var(--base-input-disabled-bgc);
  cursor: default;
}

.input-disabled {
  background-color: transparent !important;
  cursor: default;
}
</style>
